import { render, staticRenderFns } from "./PopupsSection.vue?vue&type=template&id=6b345ad6"
import script from "./PopupsSection.vue?vue&type=script&lang=js"
export * from "./PopupsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports